/**
 * Proof band — honest, verifiable capability claims.
 * (Replaces fabricated user/clinician counts: false metrics are a credibility
 * and trust risk on a healthcare platform.)
 */
const PROOF = [
  { value: '16', label: 'Regions covered', sub: 'Care in every region of Ghana' },
  { value: 'NHIS', label: 'Built in', sub: 'Verify your card & file claims online' },
  { value: 'MDC · NMC', label: 'Verified providers', sub: 'Every clinician is credential-checked' },
  { value: '256-bit', label: 'Encrypted', sub: 'Your health records stay private' },
];

export default function Stats() {
  return (
    <section className="stats-section" aria-label="Why Heka.care">
      <div className="stats-grid">
        {PROOF.map((p) => (
          <div className="stat-item" key={p.label}>
            <span className="stat-num">{p.value}</span>
            <span className="stat-label">{p.label}</span>
            <span className="stat-sub">{p.sub}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
